import React, { useState } from 'react'
import './BonusDetails.css'
import { AiOutlineClose } from "react-icons/ai";
import DropdownBonus from './DropDownBonus';

const BonusDetails = ({ showBonusdetails, toggleBonusDetails }) => {
  const [activeTab, setActiveTab] = useState('details');
  const [selectedBonusType, setSelectedBonusType] = useState('All Bonus Type');

  const bonusData = [
    { type: 'Quest Bonus', claimed: '$0.00' },
    { type: 'Lucky Spin', claimed: '$0.00' },
    { type: 'Roll Competition', claimed: '$0.00' },
    { type: 'Recharge', claimed: '$0.00' },
    { type: 'Weekly Bonus', claimed: '$0.00' },
    { type: 'Monthly Bonus', claimed: '$0.00' },
    { type: 'Sports Weekly Bonus', claimed: '$0.00' },
    { type: 'Level-up Bonus', claimed: '$0.00' },
    { type: 'Free Spin', claimed: '$0.00' },
    { type: 'Deposit Bonus', claimed: '$0.00' },
  ];
  const bonusTypes = [
    'All Bonus Type',
    'Quest Bonus',
    'Lucky Spin',
    'Roll Competition',
    'Deposit Bonus',
    'Recharge',
    'Weekly Bonus',
    'Monthly Bonus',
  ];

  return (
    <div>
      {showBonusdetails && (
        <div className="bonus-modal">
          <div className="bonusdetails-modal">
            <div className='bonusdetails-header'>
              Bonus Detail
              <div className='bonusdetails-closebtn' onClick={toggleBonusDetails}>
                <AiOutlineClose />
              </div>
            </div>

            <div className="bonusdetails-tabs">
              <button
                className={`bonusdetails-tab ${activeTab === 'overview' ? 'active' : ''}`}
                onClick={() => setActiveTab('overview')}
              >
                Overview
              </button>
              <button
                className={`bonusdetails-tab ${activeTab === 'history' ? 'active' : ''}`}
                onClick={() => setActiveTab('history')}
              >
                Transaction
              </button>
            </div>

            <div className="bonusdetails-content">
              {activeTab === 'overview' && (
                <div>
                  <div className='bonusdetails-head '>
                    <div className='head1 '>Bonus Type</div>
                    <div className='head2'>Total Claimed</div>
                  </div>
                  <div className="bonus-details-list">
                    {bonusData.map((bonus, index) => (
                      <div key={index} className="bonus-details-item">
                        <span className="bonus-type">{bonus.type}</span>
                        <span className="bonus-claimed">{bonus.claimed}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {activeTab === 'history' && (
                <div className="bonus-history ">
                  <h3 className='game-fonts'>Bonus Transaction</h3>
                  <p className='game-fonts'>Only the latest 60 days transactions will be displayed below.</p>
                  <div className="bonus-dropdown">

                    <DropdownBonus />
                  </div>

                  <div className='bonusdetail-type'>
                    <div>Bonus Type</div>
                    <div>Amount Claimed</div>
                  </div>
                  <div className='bonusdetail-transtion'>
                    <div className='bonusdetail-transtionimg'><img src='assets/bcimages/bonus/empty.webp' /></div>
                    <div>Oops! There is no data yet!</div>
                  </div>
                </div>


              )}
            </div>


          </div>
        </div>



      )}
    </div>
  )
}

export default BonusDetails
